import React from 'react';
import SpeakersFormContainer from '../../../../Containers/AdminContainer/Speakers/SpeakersForm';
import AdminLayout from '../../../../Components/CommonComponents/Layout/adminLayout';

const SpeakersFormScreen = () => {
  return <SpeakersFormContainer />;
};

export default SpeakersFormScreen;
